import {
    DATA_PROVIDER_OPTIONS,
    DERIVED_SERVICE_PROVIDER_DASHBOARDS,
    FIXED_SERVICE_PROVIDER_DASHBOARDS,
    SERVICE_PROVIDER_FEEDS,
    get_property_service_provider_assignments,
    save_property_service_provider_assignments
} from "@/utils/property_service_provider_assignments";

export default {
    name: "SettingsServiceProviderTab",

    props: {
        properties: {
            type: Array,
            default: () => []
        },
        active_property_id: {
            type: [String, Number],
            default: ""
        }
    },

    data() {
        return ({
            selected_property_id: "",
            assignments: {},
            saved_message: ""
        });
    },

    computed: {
        active_properties() {
            return this.properties.filter((property) => property.is_active);
        },

        selected_property() {
            return this.active_properties.find((property) => String(property.id) === String(this.selected_property_id)) || null;
        },

        provider_feeds() {
            return SERVICE_PROVIDER_FEEDS;
        },

        fixed_dashboards() {
            return FIXED_SERVICE_PROVIDER_DASHBOARDS;
        },

        derived_dashboards() {
            return DERIVED_SERVICE_PROVIDER_DASHBOARDS;
        },

        assigned_feed_count() {
            return SERVICE_PROVIDER_FEEDS.filter((feed) => this.assignments[feed.id]).length;
        }
    },

    watch: {
        active_properties: {
            immediate: true,
            handler(properties) {
                const selected_property_exists = properties.some((property) => String(property.id) === String(this.selected_property_id));

                if (!selected_property_exists) {
                    this.selected_property_id = this.get_initial_property_id(properties);
                }
            }
        },

        active_property_id: {
            immediate: true,
            handler(property_id) {
                if (property_id && this.property_exists(property_id)) {
                    this.selected_property_id = property_id;
                }
            }
        },

        selected_property_id: {
            immediate: true,
            handler(property_id) {
                this.saved_message = "";
                this.assignments = property_id
                    ? get_property_service_provider_assignments(property_id)
                    : {};
            }
        }
    },

    methods: {
        property_exists(property_id) {
            return this.active_properties.some((property) => String(property.id) === String(property_id));
        },

        get_initial_property_id(properties) {
            return this.property_exists(this.active_property_id)
                ? this.active_property_id
                : properties[0]?.id || "";
        },

        get_feed_provider_id(feed_id) {
            const feed = SERVICE_PROVIDER_FEEDS.find((feed) => feed.id === feed_id);
            const provider_id = this.assignments[feed_id];
            const provider_exists = feed?.provider_ids.includes(provider_id);

            return provider_exists ? provider_id : feed?.default_provider;
        },

        get_feed_provider_options(feed_id) {
            const feed = SERVICE_PROVIDER_FEEDS.find((feed) => feed.id === feed_id);

            return DATA_PROVIDER_OPTIONS.filter((provider) => feed?.provider_ids.includes(provider.id));
        },

        set_feed_provider(feed_id, provider_id) {
            this.assignments = {
                ...this.assignments,
                [feed_id]: provider_id
            };
            this.saved_message = "";
        },

        save_assignments() {
            if (!this.selected_property_id) {
                return;
            }

            this.assignments = save_property_service_provider_assignments(this.selected_property_id, this.assignments);
            this.saved_message = `Service provider assignments saved for ${this.selected_property.name}.`;
        }
    },

    DATA_PROVIDER_OPTIONS
};
